export function getMediafileType(file: string) {
  const fileExtension = file.match(/\.[0-9a-z]+$/ig)?.[0].toLowerCase();
  
  if(!fileExtension) return "unknown"
  if(fileExtension === ".mp4") return "video"
  if([".jpg", ".jpeg", ".png"].includes(fileExtension)) return "image"
}